import crypto from 'crypto-js';
export const tokenString = 'rt';
const key = process.env.REACT_APP_REFRESH_TOKEN_KEY;
const encryptString = (text) => {
    return crypto.AES.encrypt(text, key || '').toString();
};
const decryptString = (encryptedData) => {
    const bytes = crypto.AES.decrypt(encryptedData, key || '');
    return bytes.toString(crypto.enc.Utf8);
};
export const setRefreshToken = (refreshToken) => {
    const encryptedToken = encryptString(refreshToken);
    sessionStorage.setItem(tokenString, JSON.stringify(encryptedToken));
};
export const getRefreshToken = () => {
    const data = sessionStorage.getItem(tokenString);
    if (data) {
        const encryptedData = JSON.parse(data);
        return decryptString(encryptedData);
    }
    return undefined;
};
export const removeRefreshToken = () => {
    sessionStorage.removeItem(tokenString);
};
//# sourceMappingURL=index.js.map